import { css } from '@emotion/css';

export const viewMapButtonStyles = css`
  border-radius: 0.6rem;
`;
